<template>
    <rkm-modal
        class="rkm-modal"
        large
        ref="RkmModal"
        title="Veículo próprio"
    >
        <Form
            :data="data"
            :index="index"
            @save="close()"
            ref="Form"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="handleSave"
                color="primary"
            >
                {{isUpdate ? 'Alterar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: 0,
        isUpdate: false,
    }),
    methods: {
        async open(row) {

            this.$refs.RkmModal.show()

            if (row) {

                this.isUpdate = true

                this.index = row.index

                await this.$nextTick()

                this.$refs.Form.setModel({
                    modelo: row.item.modelo,
                    ano: row.item.ano,
                })
            } else {

                this.index = this.data.model.veiculos.length
            }
        },
        handleSave() {
            this.$refs.Form.save()
        },
        close() {
            this.$refs.RkmModal.hide()
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>